import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8eab6f00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "result-list" }

import { ref, watch, computed } from 'vue'
import { t } from '@/plugins/i18n'
import ListSort from './components/ListSort.vue'
import ProductListGrid from './components/ProductListGrid.vue'
import ShopListGrid from './components/ShopListGrid.vue'
import BrandListGrid from './components/BrandListGrid.vue'
import { goodsProductList, goodsShopList } from '@/apis/usercenter'
import { brandFavoriteList } from '@/apis/brand'
import { useRequest } from '@/util/useLoading'
import { useRoute } from 'vue-router'
import { useSite2Station, isMultiStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tabList = [
  { label: t('我收藏的商品'), value: 0, api: goodsProductList },
  { label: t('我收藏的店铺'), value: 1, api: goodsShopList },
  { label: t('我收藏的品牌'), value: 2, api: brandFavoriteList }
]

const route = useRoute()
const name = route.name

const tab = ref()
// 是否展示国家筛选
const isShowSelectCountry = computed(() => Number(tab.value) !== 1 && isMultiStore())
const sortTypes = computed(() => {
  let data:any = tab.value
    ? [
      { label: t('收藏时间'), bothway: true, name: 'update_time' }

    ]
    : [
      { label: t('收藏时间'), bothway: true, name: 'update_time' },
      { label: t('价格'), bothway: true, name: 'product_sell_price' }

    ].fort()
  // 当不为收藏的店铺，若是授权了韩国商品都要展示下面select
  if (isShowSelectCountry.value) {
    data.push({
      label: tab.value ? t('品牌所属国家') : t('商品所属国家'),
      select: true,
      fixLabel: tab.value ? t('品牌') : t('商品'),
      name: 'country',
      selectClass: tab.value ? 'select-brand' : 'select-goods',
      selectOption: [
        { value: '', label: t('全部国家') },
        { value: 'KR', label: t('韩国'), logo: 'https://static-s.theckb.com/BusinessMarket/Client/country/KoreaIconBorder@3x.png' },
        { value: 'CN', label: t('中国'), logo: 'https://static-s.theckb.com/BusinessMarket/Client/country/ChinaIcon@3x.png' }
      ]
    })
  }
  const { country = '' } = route.query
  //   若是授权韩国商品，但是选择的是全部国家商品，那么价格不做展示
  if (!country && isShowSelectCountry.value) {
    data = data.filter((item:any) => item.name !== 'product_sell_price')
  }
  return data
})

const [loading, api] = useRequest(() => {
  const row: any = tab.value ? tabList.find(e => e.value === tab.value) : tabList[0]
  //   选择全部国家商品
  const isSelectAllCoutry = !params.value.country
  const { sortType } = params.value ?? {}
  let newParamsValue = params.value
  //   若是授权韩国商品，但是选择的是全部国家商品，那么价格不做展示，所以要将值过滤掉
  if (isSelectAllCoutry && isShowSelectCountry.value && sortType === 'product_sell_price') {
    newParamsValue = {
      ...params.value,
      descendOrder: undefined,
      sortType: undefined

    }
  }
  return row.api(newParamsValue).then((res: any) => {
    if (res.success) {
      num.value++
      requestAnimationFrame(() => {
        data.value = res.data
      })
    }
  })
})

const mixin = (obj1: any, obj2: any) => {
  Object.entries(obj1).forEach(([k, v]) => {
    obj2[k] = obj2[k] ?? v
  })
  return obj2
}
// 默认全部国家
const params: any = ref()
const data: any = ref({})
const num = ref(0)

watch(params, () => api(), { deep: true })
watch(
  route,
  (v) => {
    if (v.name !== name) return
    tab.value = v.query?.tab ? Number(route.query.tab) : 0
    const query = { ...v.query }
    if (query.descendOrder) {
      query.descendOrder = JSON.parse(query.descendOrder.toString())
    }
    if (query.tab) {
      delete query.tab
    }
    params.value = mixin(
      {
        pageNum: 1,
        pageSize: 50,
        // 若是韩国商品授权了,默认展示为全部
        country: isShowSelectCountry.value ? '' : undefined
      },
      query
    )
    // 当没有选择国家选项时，直接传undefined
    if (!isShowSelectCountry.value) {
      params.value.country = undefined
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ListSort, {
      params: params.value,
      sortTypes: _unref(sortTypes),
      tabList: tabList
    }, null, 8, ["params", "sortTypes"]),
    (tab.value===0)
      ? (_openBlock(), _createBlock(ProductListGrid, {
          pageNum: params.value.pageNum,
          "onUpdate:pageNum": _cache[0] || (_cache[0] = ($event: any) => ((params.value.pageNum) = $event)),
          pageSize: params.value.pageSize,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((params.value.pageSize) = $event)),
          data: data.value,
          key: num.value,
          behaviorChannel: 5,
          type: "collect",
          onSuccess: _cache[2] || (_cache[2] = ($event: any) => (_unref(api)())),
          currencyCode: params.value.country
        }, null, 8, ["pageNum", "pageSize", "data", "currencyCode"]))
      : _createCommentVNode("", true),
    (tab.value===1)
      ? (_openBlock(), _createBlock(ShopListGrid, {
          pageNum: params.value.pageNum,
          "onUpdate:pageNum": _cache[3] || (_cache[3] = ($event: any) => ((params.value.pageNum) = $event)),
          pageSize: params.value.pageSize,
          "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((params.value.pageSize) = $event)),
          data: data.value,
          key: num.value,
          behaviorChannel: 5,
          type: "collect",
          onSuccess: _cache[5] || (_cache[5] = ($event: any) => (_unref(api)()))
        }, null, 8, ["pageNum", "pageSize", "data"]))
      : _createCommentVNode("", true),
    (tab.value===2)
      ? (_openBlock(), _createBlock(BrandListGrid, {
          pageNum: params.value.pageNum,
          "onUpdate:pageNum": _cache[6] || (_cache[6] = ($event: any) => ((params.value.pageNum) = $event)),
          pageSize: params.value.pageSize,
          "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((params.value.pageSize) = $event)),
          data: data.value,
          key: num.value,
          behaviorChannel: 5,
          type: "collect",
          onSuccess: _cache[8] || (_cache[8] = ($event: any) => (_unref(api)()))
        }, null, 8, ["pageNum", "pageSize", "data"]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_loading, _unref(loading)]
  ])
}
}

})